//Directives que ficarão disponíveis de forma global no scope do Vue
import Vue from 'vue';

import VueMask from 'v-mask'
Vue.use(VueMask);
